import { getCompanies } from '../../helpers/backend-helper';
import React, { useEffect, useState } from 'react'
import { Dropdown } from "primereact/dropdown"
import {
    Col,
    Container,
    Row,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"
import { getCookie } from "../../helpers/cookie"
import axios from 'axios';
import DataTable from 'react-data-table-component';

const Department = () => {
    const token = getCookie('access_token');

    const [selectedCompany, setSelectedCompany] = useState(null)
    const [company, setCompany] = useState([])
    const [departments, setDepartments] = useState([])
    const columns = [
        {
            name: 'Department Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Created At',
            selector: row => row.created_at,
        }
    ];
const customStyles = {
  headCells: {
    style: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#000",
      backgroundColor: "#f4f4f4",
    },
  },
  cells: {
    style: {
      fontSize: "16px",
      color: "#333",
    },
  },
};
    const gerDepartments = async (selectedCompanyid) => {
        try {
            const id = selectedCompanyid === undefined ? "" : `company_id=${selectedCompanyid}`;
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/departments/?${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                console.log("Departments fetched:", response.data);
                setDepartments(response.data.results
                );
            }
        } catch (error) {
            console.error("Error fetching departments:", error);
        }

    }
    const getCompanyData = async () => {
        try {
            const response = await getCompanies();
            if (response && response.results) {
                const transformedCompanies = response.results.map((company, index) => ({
                    name: company.name || company.company_name,
                    id: String(company.id || `company-${index}`),
                    __original: company
                }));

                console.log("Transformed companies:", transformedCompanies);
                setCompany(transformedCompanies);
            }
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };
    useEffect(() => {
        getCompanyData();
        gerDepartments();
    }, []);
    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
                <Container fluid={true}>
                    <div className="d-flex justify-content-between align-items-center mt-3 ">
                        <div>
                            <h4 className="mb-0">Department</h4>
                        </div>
                        <div className="d-flex mb-3">
                            <Dropdown
                                id="company"
                                value={selectedCompany}
                                options={company}
                                onChange={e => { setSelectedCompany(e.value);gerDepartments(e.value); }}
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Company"
                                className="w-full bgclr"
                                style={{ width: "250px", backgroundColor: "#fff" }}
                            />
                        </div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={departments}
                        pagination
                        customStyles={customStyles}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Department
